<template>
  <article class="transform-your-future-2024" :class="$config.platform">
    <Hero :stats="stats" :assets="assets.hero" :benefits="benefits">
      <template slot="title">
        <h1 class="main">
          <div class="text-1">
            BECOME THE <span v-if="$config.platform === 'fa'">MOST</span>
          </div>
          <div class="text-2">
            <img :class="[{ 'desktop-only': $config.platform === 'ds' }, $config.platform]" :src="require(`@itbpbg/lms-components/src/assets/images/campaigns/${$config.platform}-mw-title.webp`)">
            <img v-if="$config.platform === 'ds'" :class="['mobile-only', $config.platform]" :src="require(`@itbpbg/lms-components/src/assets/images/campaigns/${$config.platform}-mw-title-center.webp`)">
          </div>
        </h1>
        <div class="text-3">
          <span v-if="$config.platform === 'ds'" class="block">DATA AND AI EXPERT</span>
          <span v-else class="highlight campaign-fa-2">FINANCE EXPERT</span>
        </div>
        <div class="text-4">
          Within <strong class="highlight campaign-2 campaign-fa-3">1 Year</strong> <br class="mobile-only">at <strong class="highlight campaign-3 white-fa">65% OFF</strong>
        </div>
      </template>
      <div slot="content" class="card">
        <p class="label">
          Limited-Time Offer
        </p>
        <p class="old-price">
          <span class="del">&nbsp;${{ page.prices.basePrice.toFixed(2) }}&nbsp;</span>
        </p>
        <p class="new-price">
          <span>${{ priceSplitted[0] }}</span>
          <span v-if="priceSplitted[1]" class="medium">.{{ priceSplitted[1] }}</span>
          <span class="small">/year</span>
        </p>
        <p class="text">
          Billed Annually
        </p>
        <CounterWithDiscount
          v-if="countdown"
          :key="promotion.discount"
          :end-date="countdownEndDate"
          counter-class="filled mw"
        />
        <nuxt-link :to="`/checkout/?plan=annual&coupon=${promotion.coupon}`" class="btn-primary campaign-1 submit">
          Get Annual Plan
        </nuxt-link>
        <template v-if="$config.platform === 'ds'">
          <p class="card-text">
            30-day unconditional money-back guarantee
          </p>
          <p class="card-text">
            Price-lock guarantee
          </p>
        </template>
        <template v-else>
          <p class="card-text">
            Price-lock guarantee
          </p>
          <p class="card-text">
            30-day unconditional money-back guarantee
          </p>
        </template>
        <div v-if="assets.hero.stamp" class="stamp">
          <img :src="require(`../assets/images/campaigns/${$config.platform}-mw-hero-stamp.webp`)">
        </div>
      </div>
      <template slot="footer-text">
        Get an <strong>Annual Plan</strong> at <strong>65% OFF</strong> with a price-lock and money-back guarantee.
      </template>
    </Hero>
    <Courses :courses="courses">
      <template slot="title">
        <span v-if="$config.platform === 'ds'">Learn <strong class="highlight campaign-1">Data Science</strong> with Instructors from</span>
        <span v-else>Learn Finance with <strong class="highlight campaign-3">Instructors</strong> from</span>
        <Companies
          v-if="companies && companies.length" :companies="companies"
          title="" no-fill
        />
      </template>
    </Courses>
    <Videos v-if="$config.platform === 'ds'" :videos="videos" :video-js-loaded="videoJsLoaded">
      <template slot="title">
        What Do <span class="highlight campaign-2">Our Graduates</span> Say About 365 Data Science?
      </template>
    </Videos>
    <BenefitCards :benefits="benefitCards" button-class="campaign-1" @subscribe="subscribe">
      <template slot="title">
        What Will <span class="highlight campaign-3">You</span> Get?
      </template>
      <StatsIcons slot="footer" :stats="stats" />
    </BenefitCards>
    <HomeSectionInfinite
      v-if="projects && projects.length"
      classes="projects dark"
      title-class="title-highlight"
      :subtitle="`Bridge the gap between theoretical knowledge and practical implementation by working on real-world ${$config.platform === 'ds' ? 'data' : 'finance'} projects and gather valuable experience for your portfolio. Start with beginner-friendly projects or explore advanced topics to challenge yourself.`"
      :sections="projects"
      section-slug="projects"
      section-button-title="Explore Projects Library"
      hidden-button
      target-blank
    >
      <template slot="title">
        Boost Your Portfolio with <span class="highlight campaign-2 campaign-fa-3">Real-World</span>
        <span class="highlight campaign-2 campaign-fa-3 block">{{ $config.platform === 'ds' ? 'Data' : 'Finance' }} Projects</span>
      </template>
      <button
        slot="button"
        class="btn-primary campaign-2" @click="subscribe"
      >
        Start Today
      </button>
    </HomeSectionInfinite>
    <section class="long-reviews-holder">
      <Reviews
        title-slot title-class="title-reset title-highlight"
        class="long-reviews" dark unique-class="second"
      >
        <template slot="title">
          Join a Vibrant Community of
          <span class="highlight campaign-1 campaign-fa-3 mobile-block">2M+ Students</span>
        </template>
      </Reviews>
    </section>
    <section class="limited-offer-holder">
      <LimitedOffer
        :options="limitedOfferOptions"
        :features="limitedOfferFeatures"
        campaign-page class-name="col-8"
        @subscribe="$router.push(`/checkout/?plan=annual&coupon=${promotion.coupon}`)"
      >
        <template slot="pre-title">
          <span v-if="$config.platform === 'ds'">Acquire the</span>
          <span v-else>ACQUIRE THE MOST</span>
        </template>
      </LimitedOffer>
      <img
        v-show="$store.state.layout === 'desktop'"
        :src="require(`../assets/images/campaigns/${assets.footer.background}`)"
        class="limited-offer-background desktop-only"
      >
      <img
        :src="require(`../assets/images/campaigns/${assets.footer.backgroundMobile}`)"
        class="limited-offer-background mobile-only"
      >
    </section>
    <client-only>
      <BottomBanner
        v-if="$store.state.layout === 'desktop'"
        :key="1 + countdownEndDate.getTime()"
        :options="bottomBannerOptions"
        :discount="promotion.discount"
        :closed="bannerClosed"
        :style="{ 'background-image': `url(${require(`../assets/images/campaigns/${$config.platform}-mw-bg-bottom-banner.webp`)})` }"
        @subscribe="subscribe"
        @close="closeBanner"
      >
        <div slot="heading" :class="$config.platform">
          <div class="left">
            <template v-if="$config.platform === 'ds'">
              <img class="desktop-only" :src="require(`@itbpbg/lms-components/src/assets/images/campaigns/${$config.platform}-mw-title.webp`)">
              <img v-if="$config.platform === 'ds'" class="laptop-only" :src="require(`@itbpbg/lms-components/src/assets/images/campaigns/${$config.platform}-mw-title-left.webp`)">
              <span class="block"><span class="highlight campaign-1">DATA</span> AND <span class="highlight campaign-2">AI</span> COURSES</span>
            </template>
            <template v-else>
              <span class="block">MOST <img class="inline-block" :src="require(`@itbpbg/lms-components/src/assets/images/campaigns/${$config.platform}-mw-title.webp`)"></span>
              <span class="highlight campaign-3">FINANCE COURSES</span>
            </template>
          </div>
          <div class="right highlight campaign-fa-2">
            65% OFF
          </div>
        </div>
        <CounterWithDiscount
          slot="countdown"
          :end-date="countdownEndDate" banner
          discount-text="Current Discount"
          counter-class="cfp white"
        />
      </BottomBanner>
    </client-only>
  </article>
</template>

<script>
import { CAMPAIGN_PROMOTIONS } from '@itbpbg/lms-components/src/utils/campaigns';
import { getPromotion, dateInRightInterval } from '@itbpbg/lms-components/src/utils/helper';
import global from '@itbpbg/lms-components/src/mixins/global';
import CounterWithDiscount from '@itbpbg/lms-components/src/CounterWithDiscount';
import Videos from '@itbpbg/lms-components/src/Campaigns/Videos';
import Companies from '@itbpbg/lms-components/src/Campaigns/Companies';
import Hero from '../components/Campaigns/Hero';
import Courses from '../components/Campaigns/Courses';
import StatsIcons from '../components/Campaigns/StatsIcons';
import BenefitCards from '../components/Campaigns/BenefitCards';
import Reviews from '../components/Landing/Reviews';
import LimitedOffer from '../components/Landing/LimitedOffer';
import BottomBanner from '../components/Landing/BottomBanner';
import HomeSectionInfinite from '../components/Home/HomeSectionInfinite';

export default {
  components: {
    Reviews,
    BottomBanner,
    CounterWithDiscount,
    Hero,
    Companies,
    Courses,
    StatsIcons,
    BenefitCards,
    Videos,
    LimitedOffer,
    HomeSectionInfinite,
  },
  mixins: [global],
  async asyncData({
    $axios,
    $config,
    route,
    error,
  }) {
    const {
      page, courses, stats, projects,
    } = await $axios.$get('/pages/campaign/most-wanted-2024?projects=1')
      .catch(() => error({ statusCode: 404, message: 'Page not found' }));

    page.fullPath = `${$config.siteUrl}${route.fullPath}`;
    page.created = page.created || new Date();
    page.updated = page.updated || new Date();

    return {
      courses, stats, page, projects,
    };
  },
  data() {
    return {
      page: {},
      assets: {
        hero: {
          stamp: true,
          background: `${this.$config.platform}-mw-bg-hero.webp`,
          backgroundMobile: `${this.$config.platform}-mw-bg-hero-mobile.webp`,
        },
        footer: {
          background: `${this.$config.platform}-mw-bg-footer.webp`,
          backgroundMobile: `${this.$config.platform}-mw-bg-footer-mobile.webp`,
        },
      },
      videoJsLoaded: false,
      bannerClosed: false,
      countdownEndDate: this.saleEndDate(),
      promotion: {},
      countdown: {
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00',
      },
      benefitCards: {
        description: (this.$config.platform === 'ds' ? '365 Data Science provides a holistic view of data science, including the technical expertise, analytical thinking, and business acumen needed to ensure long-term success in a dynamic job market. Enjoy our ready-made structured curriculum, hands-on data projects based on real use cases, practice-based exams, and trusted certificates of achievement.' : '365 Financial Analyst provides a holistic training program in finance, including the technical expertise, analytical thinking, and business acumen needed to ensure long-term success in a dynamic job market. Enjoy our ready-made structured curriculum, hands-on finance projects based on real use cases, practice-based exams, and trusted certificates of achievement.'),
        button: 'Save 65%',
        cards: [
          {
            title: 'Custom Learning Path',
            text: 'Build the ideal learning journey for your desired job and strengthen your abilities with a personalized skill track.',
            image: 'mw-clp',
          },
          {
            title: 'Career Tracks',
            text: (this.$config.platform === 'ds' ? 'Embark on a pre-established data science career path. Choose the electives that best suit your needs and obtain highly sought-after role-specific skills.' : 'Embark on a pre-established finance career path, choose the electives that best suit your needs, and obtain highly sought-after role-specific skills.'),
            image: 'mw-tracks',
          },
          {
            title: 'Hands-On Projects',
            text: (this.$config.platform === 'ds' ? 'Boost your portfolio with real-world data projects based on actionable use cases that provide valuable business insights.' : 'Boost your portfolio with real-world finance projects based on actionable use cases that provide valuable business insights.'),
            image: 'mw-projects',
          },
          {
            title: 'Practical Exams',
            text: (this.$config.platform === 'ds' ? 'Test your newfound data science, programming, machine learning, and AI skills with our practice, course, and career track exams.' : 'Test your newfound Excel, financial analysis and modeling, valuation, financial planning, accounting, corporate finance, portfolio management, investment banking skills with our practice, course, and career track exams.'),
            image: 'mw-exams',
          },
          {
            title: 'Certificates of Achievement',
            text: (this.$config.platform === 'ds' ? 'Prove you’re a competent data professional by earning data science certificates recognized by employers.' : 'Prove you’re a competent finance professional by earning verifiable certificates recognized by employers.'),
            image: 'mw-certificate',
          },
          {
            title: 'Resume Builder',
            text: (this.$config.platform === 'ds' ? 'Create a sharp and compelling data science resume with an information-rich summary and certification to grab the attention of recruiters and hiring managers.' : 'Create a sharp and compelling resume to grab the attention of recruiters and hiring managers with an information-rich summary and certification.'),
            image: 'mw-resume',
          },
          {
            title: 'Social Channels',
            text: (this.$config.platform === 'ds' ? 'Build your professional network, exchange experiences with like-minded individuals, and receive support from your instructors.' : 'Build your professional network, exchange experiences with like-minded individuals, and receive support from your instructors.'),
            image: 'mw-channels',
          },
          {
            title: 'Gamified Features',
            text: (this.$config.platform === 'ds' ? 'Transform your data science learning into a motivating journey. Set daily goals, earn in-platform currency, collect exclusive cards, and unlock exciting rewards.' : 'Transform your learning into a motivating journey. Set daily goals, earn in-platform currency, collect exclusive cards, and unlock exciting rewards.'),
            image: 'mw-xp',
          },
          {
            title: 'Competitive Leaderboard',
            text: 'Rise in the weekly ranks through XPs and blow the competition away with your relentless determination to climb to the top.',
            image: 'mw-leaderboard',
          },
        ],
      },
      programStatsData: {
        title: 'Embark on an <strong class="highlight yellow fa-blue">EXPERT-LED PATH</strong> to Career Success',
        subtitle: (this.$config.platform === 'ds' ? 'Build your data science and AI skills from the ground up. Equip yourself with the essential tools to succeed and remain competitive in a rapidly changing job market with our comprehensive, structured training program.' : 'Take your finance skills to the next level. From the fundamentals to the most advanced topics, our all-in-one training is perfect for individuals who want to start or advance their finance careers. Enroll in proven bestseller courses to learn practical skills and become a sought-after financial professional.'),
      },
      companies: [
        ...(this.$config.platform === 'ds' ? [
          { icon: 'meta-new' },
          { icon: 'netflix' },
          { icon: 'google-new' },
          { icon: 'spotify' },
          { icon: 'ikea-new' },
        ] : [
          { icon: 'hsbc-new' },
          { icon: 'morgan-stanley-new' },
          { icon: 'goldman-sachs-new' },
          { icon: 'pwc-new' },
          { icon: 'coca-cola' },
          { icon: 'ikea-new' },
        ]),
      ],
      videos: [
        { name: 'Lee', from: 'USA', id: 6315230915112 },
        { name: 'Meghan', from: 'Canada', id: 6315228912112 },
        { name: 'Julián', from: 'Mexico', id: 6343656185112 },
        { name: 'Nada', from: 'Egypt', id: 6315228795112 },
        { name: 'Ernest', from: 'Kenya', id: 6315231920112 },
        { name: 'Mihaela', from: 'Bulgaria', id: 6341101204112 },
        { name: 'Ahmed', from: 'Egypt', id: 6327293863112 },
      ],
      modules: {
        ds: {
          0: { subtitle: 'Develop the top-level data science skills needed to become the most sought-after professional that drives value in any organization.' },
          1: { subtitle: 'Gain the skills for a data analyst career. Solve issues through an analytical lens and empower businesses to make informed decisions.' },
          2: { subtitle: 'Build the necessary skills for a business analyst job. Help organizations make data-driven decisions and create long-lasting impact.' },
        },
        fa: {
          0: { subtitle: 'Learn everything you need to build a successful financial analysis career. Acquire robust accounting, financial planning, analysis, and reporting skills.' },
          1: { subtitle: 'Prepare for this demanding career by learning financial modeling, investment banking, and corporate finance.' },
          2: { subtitle: 'Gain the skills to research and assess potential investment opportunities and become a sought-after investment analyst or associate.' },
        },
      },
    };
  },
  head() {
    const linkedData = this.$linkedDataLoad([
      { key: 'WebSite' },
      { key: 'WebPage', values: this.page },
    ]);

    return {
      titleTemplate: `${this.page.metaTitle}`,
      link: [{ rel: 'canonical', href: this.canonicalURL() }],
      meta: this.metaProps({ ...this.page, metaImage: `og-campaign-${this.$config.platform}-most-wanted-2024.webp` }),
      script: [
        linkedData,
        {
          src:
            'https://players.brightcove.net/6258000438001/FHDad0Z7G_default/index.min.js',
          async: true,
        },
      ],
    };
  },
  computed: {
    mobile() {
      if (this.$store.state.layout !== 'desktop') {
        return '-mobile';
      }

      return '';
    },
    benefits() {
      if (this.$config.platform === 'fa') {
        return [
          `Access ${this.stats.rounded.courses} expert-led courses.`,
          'Learn Excel, financial analysis and modeling, valuation, financial planning, accounting, corporate finance, portfolio management, investment banking, and more.',
          'Earn industry-recognized certificates.',
          'Build the skillset, resume, and portfolio that gets you hired.',
        ];
      }

      return [
        `Access ${this.stats.rounded.courses} expert-led courses.`,
        ' Learn Python, SQL, machine learning, AI, ChatGPT, Tableau, Power BI, and more.',
        'Earn industry-recognized certificates.',
        'Build the skillset, resume, and portfolio that gets you hired.',
      ];
    },
    limitedOfferOptions() {
      const price = this.page && this.page.prices.price ? this.page.prices.price : 119;
      const baseAnnualPrice = this.page && this.page.prices.basePriceComparison ? this.page.prices.basePriceComparison : 432;

      return {
        preTitleSlot: true,
        htmltitle: `<img class="block desktop-only" src="${require(`@itbpbg/lms-components/src/assets/images/campaigns/${this.$config.platform}-mw-title.webp`)}" />${this.$config.platform === 'ds' ? `<img class="block mobile-only" src="${require(`@itbpbg/lms-components/src/assets/images/campaigns/${this.$config.platform}-mw-title-center.webp`)}" />` : ''}<span class="block highlight campaign-1 campaign-fa-2 text-2">${this.$config.platform === 'ds' ? 'DATA AND AI' : 'FINANCE'} SKILLS</span> <span class="block text-3">Get a <span class="fa-block">365 Annual Plan</span> at ${this.$config.platform === 'ds' ? '' : 'a '}<strong class="highlight campaign-3">65% ${this.$config.platform === 'ds' ? 'OFF' : 'Discount'}</strong></span>`,
        promoPlanType: 'annual',
        comparisonPlanType: 'monthly',
        comparisonPlanBilledText: 'Billed Monthly',
        promoPlanBilledText: 'Billed Annually',
        regularPrice: `$${this.page.prices.basePrice}`,
        discountedPrice: `$${price}`,
        billedComparisonPrice: `$${baseAnnualPrice}`,
        discountedPriceCharge: '/year',
        billedComparisonCharge: '/month',
        promoPlanSubscribeClass: 'subscribe-annual',
        comparisonSubscribeClass: 'subscribe-monthly',
        promoPlanButtonText: `Get ${this.promotion.discount}% Off`,
        buttonClass: 'submit',
        comparisonPlanButtonText: 'Sign up Now',
        vat: 'VAT may be applied',
        badges: this.$config.platform === 'ds',
      };
    },
    limitedOfferFeatures() {
      const data = [
        {
          name: 'World-class instructors',
        },
        {
          name: 'Employer-recognized certificates',
        },
        {
          name: 'Engaging bite-sized lessons',
        },
        {
          name: 'Resume builder',
        },
        {
          name: `${this.stats.rounded.videoDuration}+ hours of video`,
        },
        {
          name: 'Social channels for peer discussions',
        },
        {
          name: `${this.stats.rounded.exercises}+ practical exercises`,
        },
        {
          name: 'Experience points and leveling up',
        },
        {
          name: 'Structured career tracks',
        },
        {
          name: 'In-app currency and rewards',
        },
        {
          name: 'Custom learning path',
        },
        {
          name: 'Leaderboard and ranking',
        },
        {
          name: 'Real-world data projects',
        },
        {
          name: 'Exclusive hand-drawn collectible cards',
        },
        {
          name: 'Hands-on exams',
        },
        {
          name: '30-day refund',
        },
      ];

      if (this.$store.state.layout === 'mobile') {
        return [
          ...data.filter((v, i) => i % 2 === 0),
          ...data.filter((v, i) => i % 2 === 1),
        ];
      }

      return data;
    },
    signupBtnText() {
      if (this.$config.platform === 'fa') {
        return 'Get Started';
      }

      return this.$c.text('button.get-started');
    },
    pagePrices() {
      if (this.page.prices && this.page.prices.basePrice) {
        return this.page.prices;
      }

      return {};
    },
    priceSplitted() {
      return (+this.pagePrices.price || 0).toString().split('.');
    },
    bottomBannerOptions() {
      return {
        counterWithDiscount: true,
        subscribeClass: 'submit campaign-1',
        buttonText: this.$config.platform === 'ds' ? this.promotion.buttonText : 'Start Now',
        className: this.promotion.final ? 'final-promo' : '',
        transformYourFuture2024: true,
      };
    },
  },
  created() {
    this.countdownEndDate = this.saleEndDate();
  },
  async mounted() {
    this.$nextTick(() => this.toggleBanner());
    await this.$pollValue(() => typeof videojs !== 'undefined');
    this.videoJsLoaded = true;
    this.handleScroll();

    let stop = false;
    const interval = setInterval(() => {
      if (stop) {
        clearInterval(interval);
      }

      const nowDate = new Date();
      if (dateInRightInterval(nowDate)) {
        this.countdownEndDate = this.saleEndDate();
      }

      if (nowDate > new Date(this.promotion.endDateFinal)) {
        stop = true;
        window.location.href = `${this.$config.siteUrl}/offer-expired/`;
      }
    }, 1000);
  },
  methods: {
    handleScroll() {
      const scroll = () => {
        if (this.$store.state.layout === 'mobile' || this.bannerClosed) {
          return;
        }
        this.$nextTick(() => this.toggleBanner());
      };

      window.addEventListener('scroll', scroll);
      this.$once('hook:beforeDestroy', () => window.removeEventListener('scroll', scroll));
    },
    toggleBanner() {
      const bottomBanner = document.querySelector('.bottom-banner');
      const hero = document.querySelector('.hero-benefits');
      const footer = document.querySelector('.limited-offer-holder');
      let hideFromTop = false;
      let hideFromBottom = false;

      if (bottomBanner) {
        if (hero) {
          hideFromTop = hero.getBoundingClientRect().top - 100 > 0;
        }

        if (footer) {
          hideFromBottom = footer.getBoundingClientRect().top - 400 < 0;
        }

        if (hideFromTop || hideFromBottom) {
          bottomBanner.classList.remove('fixed');
        } else {
          bottomBanner.classList.add('fixed');
        }
      }
    },
    closeBanner() {
      this.bannerClosed = true;
    },
    subscribe() {
      const limitedOffer = document.querySelector('.limited-offer-holder');
      const y = limitedOffer.getBoundingClientRect().top + window.scrollY - 50;
      window.scrollTo({ top: y, behavior: 'smooth' });
    },
    saleEndDate() {
      const campaignData = CAMPAIGN_PROMOTIONS['most-wanted-2024'];
      const promoOptions = getPromotion(campaignData.promos, this.promotion);
      this.promotion = {
        buttonText: 'Start Now',
        ...promoOptions.nextPromotion,
        ...campaignData.templates,
      };
      if (promoOptions.refresh) {
        setTimeout(() => {
          window.$nuxt.refresh();
        }, 40000);
      }

      return new Date(this.promotion.endDate);
    },
  },
};
</script>

<style lang="scss">
@include bp($bp-desktop) {
  .mobile-only,
  .laptop-only {
    display: none !important;
  }
}

.block {
  display: block;
}

.highlight {
  font-weight: 700;

  &.campaign-1,
  &.blue {
    color: var(--c-mw-1);
  }

  &.campaign-2,
  &.yellow {
    color: var(--c-mw-2);
  }

  &.campaign-3,
  &.pink {
    color: var(--c-mw-3);
  }

  &.white {
    font-weight: 600;
    color: var(--main-light);
  }
}

.highlight-special {
  position: relative;
  line-height: 1.2;
  font-weight: 700;
  text-shadow: 0 0 16px rgba(252, 252, 83, 0.8);
  color: var(--main-light);
}

.fa {
  .fa-block {
    display: block;
  }

  .highlight-special {
    text-shadow: 0 0 16px #036FFD;
  }

  .highlight {
    &.fa-blue {
      color: var(--accent-light-3);
    }

    &.campaign-fa-1 {
      color: var(--c-mw-1);
    }

    &.campaign-fa-2 {
      color: var(--c-mw-2);
    }

    &.campaign-fa-3 {
      color: var(--c-mw-3);
    }

    &.white-fa {
      font-weight: 600;
      color: var(--main-light);
    }
  }
}

.mirror {
  position: relative;
  line-height: 60px;

  &:after {
    content: attr(data-mirror);
    position: absolute;
    top: -10px;
    left: 0;
    transform-origin: bottom;
    transform: rotateX(180deg);
    line-height: inherit;
    background-image: linear-gradient(0deg, #FFF 10px, transparent 60%);
    background-clip: text;
    -webkit-background-clip: text;
    -moz-background-clip: text;
    color: transparent;
    opacity: 0.3;
    filter: blur(2.2px);

    @-moz-document url-prefix() {
      opacity: 0.6;
    }
  }
}

article.transform-your-future-2024 {
  overflow: hidden;
  position: relative;

  &:before {
    content: '';
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: var(--main-dark);
    z-index: -2;
  }

  .title-highlight {
    font-size: 40px;
    line-height: 44px;
    font-weight: 400;
    text-align: center;
    color: var(--main-light);

    .title-block {
      display: block;
      margin: 0 auto;
    }
  }

  .section-subtitle {
    font-size: 21px;
    color: var(--main-light-shade-4);
  }

  .btn-primary {
    color: var(--main-dark);
    border: 2px solid var(--c-mw-1);
    background-color: var(--c-mw-1);
    font-weight: 600;
    font-size: 21px;
    border-radius: 5px;
    margin: 0 auto;
    display: block;
    height: 58px;
    line-height: 30px;
    max-width: 350px;
    width: 100%;
    margin-top: var(--spacing-60);
    padding-left: 5px;
    padding-right: 5px;

    &.submit {
      transition: all 50ms linear;
      border-color: var(--main-dark);
      background-color: var(--c-mw-1);
    }

    &:not(:disabled) {
      &:hover,
      &:active,
      &:focus {
        color: var(--main-dark);
        background-color: var(--c-mw-1);

        &:not(.submit) {
          filter: drop-shadow(0 0 30px var(--c-mw-1));
          border-color: var(--c-mw-1);
        }

        &.submit {
          background-color: var(--c-mw-1);
          border-color: var(--main-dark);
          outline: 2px solid var(--main-dark) !important;
        }
      }
    }
  }

  .limited-offer .btn-primary.submit,
  .bottom-banner .btn-primary.submit {
    background-color: var(--c-mw-2);

    &:not(:disabled) {
      &:hover,
      &:active,
      &:focus {
        color: var(--main-dark);
        background-color: var(--c-mw-2);
      }
    }
  }

  .hero {
    .content {
      padding-right: 0;

      .title {
        .main {
          font-size: 32px;

          .text-1 {
            font-weight: 700;
          }
        }

        .text-3 {
          font-size: 32px;
          font-weight: 700;
        }

        .text-4 {
          margin-top: var(--spacing-16);
          font-size: 32px;
          font-weight: 500;

          .highlight {
            font-size: 40px;
            font-weight: 900;
          }
        }
      }
    }

    .holder {
      margin-top: 0;

      .card {
        .old-price {
          color: var(--main-dark-light-2);
        }

        .btn-primary {
          margin: 20px 0 12px;
          width: 100%;
          max-width: 100%;
          height: 58px;
        }
      }

      .hero-benefits {
        margin-top: 0;
        margin-bottom: 40px;
      }

      .footer-text.mobile-only {
        text-align: center;
        color: var(--main-light);
        display: block;
      }
    }
  }

  &.ds .hero {
    min-height: 800px;
  }

  .hero-benefits .benefit svg {
    [fill] {
      fill: var(--c-mw-3) !important;
    }

    [stroke] {
      stroke: var(--c-mw-3) !important;
    }
  }

  .signup-form.form-wrap {
    max-width: 420px;
    margin-left: auto;
    padding-top: 80px;
    padding-bottom: 80px;

    .btn-primary {
      height: 63px;
      line-height: 22px;
      border: 2px solid var(--main-dark);
    }
  }

  /**** landing specific CSS ****/
  > .video {
    h2 {
      max-width: unset;
    }
  }

  .graduates-thoughts h2 {
    max-width: 670px;
  }

  > {
    .stats-icons {
      margin-bottom: var(--spacing-100);
    }
  }

  .stats-icons > div svg {
    color: var(--c-mw-3);
  }

  > section {
    padding-top: 100px;
    padding-bottom: 100px;
  }

  .courses .companies {
    .trusted-companies {
      font-size: inherit;
      border-top: none;
      padding-top: 0;

      .logos {
        display: inline-flex;

        .logo {
          svg {
            margin-right: 0;

            g[fill] {
              fill: var(--main-light-shade-4);
            }
          }

          + .logo svg {
            margin-left: 44px;
          }
        }
      }
    }
  }

  .benefit-cards,
  .courses {
    .infinite-carousel {
      .carousel {
        padding-top: 10px;
        margin-top: -10px;
        padding-bottom: 10px;
        margin-bottom: -10px;

        .card {
          margin: 0 var(--spacing-30) 0 0;
          width: 370px;
          vertical-align: top;

          .course-card-container {
            min-height: 422px;
          }

          &:not(.course-card) {
            flex-direction: column;
            align-items: flex-start;
            height: auto;
            border-radius: 0;

            .image-wrapper img {
              display: block;
              max-width: 100%;
              max-height: 100%;
              border-radius: 7px;
            }

            .card-title {
              margin-top: var(--spacing-20);
              font-size: 32px;
              color: var(--main-light);
            }

            .card-desc {
              color: var(--main-dark-shade-4);
              font-size: 21px;
              line-height: 140%;
            }
          }

          &.course-card {
            .course-card-image {
              height: 220px;
            }

            .course-card-body {
              padding: var(--spacing-20) var(--spacing-24) 20px;

              .course-name {
                margin-bottom: var(--spacing-8);
              }

              .course-rating {
                color: var(--main-light);
              }

              .info {
                color: var(--main-light);
                margin: 0;

                .dot {
                  background: var(--main-light);
                }
              }
            }
          }
        }
      }

      .controls {
        margin: var(--spacing-24) 0 var(--spacing-60);
        display: flex;
        flex-shrink: 0;
        justify-content: center;
      }
    }
  }

  .projects {
    .title-highlight {
      margin-bottom: var(--spacing-8);
    }

    .subtitle {
      width: 100%;
      max-width: 100%;
      flex: auto;
      margin: 0;
    }

    .section-link {
      margin-top: 0;

      .btn-primary {
        max-width: 350px;
      }
    }
  }

  .program-stats {
    .program-cards .container {
      .heading {
        max-width: 970px;
        margin-bottom: var(--spacing-80);

        .h2 {
          color: var(--main-light);
          margin-bottom: var(--spacing-12);
        }

        .subtitle {
          color: var(--main-light-shade-4);
          margin: 0;
        }
      }

      .modules .module {
        margin-bottom: var(--spacing-22);

        .module-body {
          .module-heading {
            .h3 {
              color: var(--main-light);
            }
          }

          .body-2 {
            width: 100%;
          }

          .module-info .course > div .course-info {
            .name {
              color: var(--main-light);
            }
          }
        }

        .module-see-more {
          bottom: 0;
          padding: var(--spacing-30);

          &:after {
            height: auto;
            bottom: 0;
            top: -80px;
          }
        }

        .module-mobile {
          font-size: 18px;
          border-radius: 0;

          span {
            color: var(--main-dark-shade-4);
          }
        }
      }
    }
  }

  .long-reviews-holder {
    position: relative;

    .long-reviews {
      .container {
        position: relative;

        .reviews-trustpilot {
          .reviews-heading > div {
            margin-bottom: var(--spacing-40);
            display: block;
          }

          .reviews-body {
            .card-trustpilot-review {
              background: var(--main-dark-shade-2);
              box-shadow: 0 16px 30px rgba(0, 12, 31, 0.08);

              .heading {
                font-size: 14px;
                margin-bottom: var(--spacing-12);
                color: var(--main-light);
              }

              .title {
                font-weight: 700;
                color: var(--main-light);
              }
            }
          }

          .see-more {
            font-size: 18px;
            line-height: 140%;
            margin-top: var(--spacing-30);
            z-index: 1;

            &:after {
              background: linear-gradient(0deg, #000C1F 0%, rgba(0, 12, 31, 0.77) 42.76%, rgba(41, 51, 67, 0) 94.04%);
              background-blend-mode: color;
              top: auto;
              bottom: 55px;
            }

            &.fa:after {
              background: linear-gradient(0deg, #011633 0%, rgba(1, 22, 51, 0.77) 42.76%, rgba(1, 22, 51, 0) 91.96%);
            }

            span {
              font-weight: 500;
            }
          }
        }
      }
    }
  }

  .limited-offer-holder {
    position: relative;

    .limited-offer {
      position: relative;
      z-index: 2;
      color: var(--main-light);

      h2 {
        margin-bottom: var(--spacing-40);
      }

      .heading {
        font-size: 40px;

        img {
          display: block;
          margin: 0 auto;
        }

        .text-2 {
          font-size: 44px;
          font-weight: 800;
        }

        .text-3 {
          font-size: 40px;
        }
      }

      .price {
        margin-top: var(--spacing-20);
        margin-bottom: var(--spacing-30);

        .regular-price {
          align-self: flex-start;
          margin-top: 10px;
          font-weight: 500;

          &:before {
            background-color: var(--main-light);
          }
        }

        .discounted-price {
          line-height: 70px;
          font-weight: 900;
          font-size: 60px;

          .promo-price {
            color: var(--c-cm-2);
          }

          .body-1 {
            font-weight: 400;
          }
        }
      }

      .plan-features {
        margin-bottom: var(--spacing-50);

        .feature {
          position: relative;
          line-height: 150%;
          margin-bottom: var(--spacing-20);

          svg {
            [fill] {
              fill: var(--c-mw-1);
            }

            [stroke] {
              stroke: var(--c-mw-1);
            }
          }
        }
      }

      hr {
        display: none;
      }

      .switch-holder {
        span:not(.unactive) {
          color: var(--main-light);
        }

        .switch {
          width: 45.69px;
          height: 22px;

          .slider:before {
            width: 16px;
            height: 16px;
            top: 3px;
            left: 3px;
          }

          // input:not(:checked) + .slider {
          //   background-color: var(--c-tyf-1);
          // }

          input:checked + .slider {
            background-color: var(--c-tyf-1);

            &:before {
              transform: translateX(23px);
            }
          }
        }
      }

      .subtitle {
        margin: 0 0 var(--spacing-12);
        color: var(--main-light);
        font-size: 32px;
        font-weight: 500;
        display: flex;
        align-items: center;
        justify-content: center;

        .title-inline {
          margin: 0 10px;
        }
      }

      .btn-primary {
        margin-top: 0;
      }

      .badges {
        margin-top: 40px;
      }

      .vat-note {
        margin-top: var(--spacing-24);
        color: var(--main-dark-shade-4);
        font-weight: 600;
        font-size: 18px;
      }
    }

    .limited-offer-background {
      position: absolute;
      top: 0;
      left: 50%;
      bottom: 0;
      height: calc(100% + 50px);
      object-fit: cover;
      transform: translateX(-50%);
    }
  }

  .bottom-banner {
    background-repeat: no-repeat;
    background-position: center;
    padding: 0;
    height: 110px;
    border-top: none;

    &:after {
      content: '';
      z-index: -1;
      position: absolute;
      display: block;
      width: 100%;
      height: 5px;
      left: 0;
      bottom: 100%;
      background: var(--c-tyf-1);
    }

    .container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }

    .campaign-heading {
      color: var(--main-light);

      .ds {
        display: flex;
        align-items: center;

        img {
          display: block;
          height: 38px;
          margin-left: -12px;
        }

        .left {
          font-size: 24px;
          font-weight: 700;
          line-height: 1.1;
        }

        .right {
          margin-left: 18px;
          font-size: 68px;
          font-weight: 800;
          line-height: 1.1;
          text-shadow: 0 0 7.6px #FF36FF, -2.119px -1.59px 0 #FF36FF, 1.59px 2.119px 0 #25F4EE;
        }
      }

      .fa {
        display: flex;
        align-items: center;

        .left {
          .block {
            display: flex;
            align-items: center;
            font-size: 28px;

            img {
              display: block;
              height: 29px;
              margin-left: 4px;
            }
          }

          .highlight {
            font-size: 24.5px;
            font-weight: 900;
          }
        }

        .right {
          font-size: 44px;
          font-weight: 800;
          margin-left: 40px;
        }
      }

      .line-1 {
        font-size: 18px;
        font-weight: 400;

        .bigger {
          font-size: 24px;
        }

        .highlight {
          font-size: 24px;
          font-weight: 600;

          ~ .highlight {
            font-size: 28px;
            font-weight: 700;
          }
        }

        b {
          font-size: 24px;
          font-weight: 900;
        }
      }

      .line-2 {
        margin-top: 5px;
        font-size: 18px;
        font-weight: 400;

        .bigger {
          font-size: 21px;
        }

        b {
          font-size: 21px;
          font-weight: 900;
        }

        .highlight {
          font-size: 21px;
          font-weight: 800;
        }
      }
    }

    .counter {
      .square .number {
        font-weight: 700;
        text-shadow: 0 0 8px var(--c-tyf-1);
      }
    }

    .btn-primary {
      width: 220px;
      line-height: 16px;
      margin: 0;
      padding-left: 0;
      padding-right: 0;
    }

    .icon-close {
      top: 19px;
      right: 14px;

      path[fill] {
        fill: var(--main-dark-light-4);
      }
    }
  }

  .long-reviews-holder .long-reviews .container .reviews-trustpilot .see-more,
  .module .module-body .module-info .course > div .course-info .number,
  .program-stats .program-cards .container .modules .module-see-more {
    color: var(--c-mw-1);

    svg {
      [fill] {
        fill: var(--c-mw-1);
      }

      [stroke] {
        stroke: var(--c-mw-1);
      }
    }
  }
}

.fa article.transform-your-future-2024 {
  .hero {
    img.fa {
      width: 400px;
    }

    .content .title {
      .text-3 {
        font-size: 46px;
      }
    }

    .holder .card .stamp {
      top: 0;
      right: 8px;

      img {
        width: 130px;
      }
    }
  }
  .courses {
    padding-top: 100px;
  }

  .btn-primary {
    &,
    &.submit {
      background-color: var(--c-mw-2);
    }

    &:not(.submit) {
      border-color: var(--c-mw-2);
    }

    &:not(:disabled) {
      &:hover,
      &:active,
      &:focus {
        color: var(--main-dark);
        background-color: var(--c-mw-2);

        &:not(.submit) {
          filter: drop-shadow(0 0 30px var(--c-mw-2));
          border-color: var(--c-mw-2);
        }

        &.submit {
          background-color: var(--c-mw-2);
          border-color: var(--main-dark);
          outline: 2px solid var(--main-dark) !important;
        }
      }
    }
  }

  .counter.mw .square {
    background-color: var(--c-mw-3);
    border-color: var(--c-mw-3);
  }

  .long-reviews-holder .long-reviews .container .reviews-trustpilot .see-more,
  .module .module-body .module-info .course > div .course-info .number,
  .program-stats .program-cards .container .modules .module-see-more,
  .limited-offer-holder .limited-offer .plan-features .feature {
    &:not(.feature) {
      color: var(--c-mw-2);
    }

    svg {
      [fill] {
        fill: var(--c-mw-2);
      }

      [stroke] {
        stroke: var(--c-mw-2);
      }
    }
  }

  .limited-offer-holder {
    padding-top: 120px;

    .vat-note,
    .limited-offer {
      .subtitle {
        margin-bottom: 0;
      }

      .heading {
        img.block:not(.highlight) {
          height: 70px;
          margin-top: 0;
        }
      }

      .switch-holder .switch input:checked + .slider {
        background-color: var(--c-mw-3);
      }

      .switch-holder .switch input:not(:checked) + .slider {
        background-color: var(--c-mw-1);
      }

      .price {
        &.comparison .discounted-price {
          color: var(--c-mw-1);

          .body-1 {
            color: var(--main-light);
          }
        }

        .discounted-price .promo-price {
          color: var(--c-mw-3);
        }
      }

      .vat-note {
        color: var(--main-light);
        font-size: 14px;
        font-weight: 500;
      }
    }

    .limited-offer-background {
      height: 100%;
    }
  }

  .bottom-banner {
    &:after {
      background-color: var(--c-mw-2);
    }
  }
}

.program-cards .container .modules .col-6:nth-of-type(2) {
  margin-top: 360px;
}

@include bp($bp-laptop) {
  .laptop-block {
    display: block;
  }

  .mirror {
    line-height: 52px;
  }

  article.transform-your-future-2024 {
    .btn-primary {
      max-width: 310px;
    }

    .hero {
      .content .title {
        .main {
          img {
            height: 50px;
          }
          .text-1 {
            font-size: 28px;
          }

          .text-2 {
            white-space: nowrap;
            font-size: 52px;
          }
        }

        .text-3 {
          font-size: 24px;
        }

        .text-4 {
          font-size: 28px;

          .highlight {
            font-size: 36px;
          }
        }
      }

      .holder .card {
        .old-price {
          font-size: 28px;
        }

        .counter.filled .square {
          width: 65px;
          height: 76px;
        }

        .label {
          font-size: 18px;
        }

        .stamp {
          right: 0;

          img {
            width: 158px;
          }
        }
      }
    }

    .signup-form.form-wrap {
      max-width: 395px;
    }

    .title-highlight,
    .slider-container.landing .slider-header .heading h2 {
      font-size: 32px;
      line-height: 1.1;

      .title-block {
        margin-top: 10px;
      }
    }

    .subtitle {
      font-size: 16px;
    }

    .benefit-cards .infinite-carousel .controls,
    .courses .infinite-carousel .controls {
      margin-bottom: var(--spacing-36);
    }

    .benefit-cards .title-highlight .title-inline {
      width: 125px;
    }

    .projects .title-highlight .title-block {
      height: 50px;
    }

    section:not(.projects) .infinite-carousel .carousel .card {
      width: 310px;

      &:not(.course-card) {
        .card-title {
          font-size: 24px;
        }

        .image-wrapper,
        .image-wrapper img {
          width: 100%;
        }
      }
    }

    .courses .title-highlight .title-block {
      height: 45px;
    }

    .long-reviews-holder .long-reviews .container .reviews-trustpilot .reviews-heading > div {
      margin-bottom: 52px;

      .h2 {
        max-width: 820px;
        font-size: 32px;

        br {
          display: none;
        }
      }
    }

    .limited-offer-holder {
      .limited-offer {
        .limited-offer-container {
          width: 700px;
          max-width: 700px;
        }

        .subtitle {
          font-size: 21px;
        }

        .heading {
          &,
          .text-2,
          .text-3 {
            font-size: 32px;
          }

          img {
            height: 60px;
          }
        }

        .subtitle .title-inline {
          width: 240px;
        }

        .price {
          margin-bottom: 46px;

          .discounted-price {
            font-size: 54px;
          }
        }

        .btn-primary {
          max-width: 310px;
        }
      }

      .limited-offer-background {
        bottom: -160px;
      }
    }

    .bottom-banner {

      .campaign-heading {
        .ds {
          img {
            margin-left: -6px;
            height: 66px;
          }

          .desktop-only {
            display: none !important;
          }

          .laptop-only {
            display: block !important;
          }

          .left {
            font-size: 16px;
          }

          .right {
            font-size: 56px;
          }
        }
      }

      .btn-primary {
        height: 58px;
      }
    }
  }
}

@include bp($bp-mobile) {
  .mobile-block {
    display: block;
  }

  .desktop-only {
    display: none !important;
  }

  .mirror {
    line-height: 52px;

    &:after {
      background-image: linear-gradient(0deg, #FFF 10px, transparent 45%);
      opacity: 0.2;

      @-moz-document url-prefix() {
        opacity: 0.6;
      }
    }
  }

  article.transform-your-future-2024 {
    section {
      padding-top: 60px;
      padding-bottom: 60px;

      &.courses {
        padding-top: 40px;
      }
    }

    .title-highlight {
      font-size: 32px;
      line-height: 1.1;

      strong:after {
        top: 2px;
        left: 2px;
      }
    }

    .hero {
      .content .title {
        .main {
          .text-1 {
            .highlight {
              font-size: 28px;
            }
          }

          .text-2 {
            img {
              display: block;
              margin: 16px auto 12px;
            }
          }
        }

        .text-3 {
          font-size: 24px;
        }

        .text-4 {
          margin-top: 20px;

          .highlight {
            font-size: 36px;
          }
        }
      }

      .holder .card {
        .stamp {
          top: 8px;
          right: 0;
          width: auto;
          height: auto;

          img {
            width: 135px;
          }
        }
      }

      .hero-background {
        height: auto;
      }

      &:after {
        content: none !important;
      }
    }

    &.fa .hero {
      .content .title {
        .main {
          .text-2 img {
            width: 100%;
            max-width: 400px;
          }
        }

        .text-3 {
          font-size: 32px;
        }

        .text-4 {
          font-size: 24px;

          .highlight {
            font-size: 28px;
          }

          br.mobile-only {
            display: none;
          }
        }
      }

      .holder .card {
        .stamp img {
          width: 96px;
          height: 96px;
        }
      }
    }

    .highlight-special {
      display: inline-block;
    }

    .btn-primary {
      margin-top: var(--spacing-44);
      width: 100%;
      max-width: 327px;
      line-height: 18px;
    }

    .signup-form.form-wrap {
      border-radius: 0;
      margin-right: auto;
    }

    .courses {
      .companies .trusted-companies {
        margin-top: 16px;
        margin-bottom: 24px;

        .logos {
          justify-content: space-around;

          .logo {
            svg {
              height: 20px;
            }

            + .logo svg {
              margin-left: 0;
            }
          }
        }
      }

      .title-highlight {
        .title-block {
          height: auto;
          margin-top: var(--spacing-8);
        }
      }
    }

    .benefit-cards .title-highlight {
      display: block;

      .title-inline {
        display: block;
        width: auto;
        margin: 10px auto;
      }
    }

    .projects .title-highlight .title-block {
      margin-top: 20px;
      width: 327px;
    }

    section:not(.projects) .infinite-carousel .carousel {
      .card {
        margin: 0;
        padding: 0 var(--spacing-24);
        width: 50%;

        &:not(.course-card) {
          .image-wrapper,
          .card-image {
            width: 100%;
          }

          .card-title {
            font-size: 24px;
          }

          .card-desc {
            font-size: 16px;
            line-height: 150%;
          }
        }
      }
    }

    .technologies-new {
      text-align: center;

      .title {
        font-size: 28px;
      }

      .image {
        margin-top: 30px;
      }
    }

    .program-stats {
      .program-cards {
        padding: 0;

        .container .heading {
          h2 {
            font-size: 32px;
          }

          .subtitle {
            font-size: 18px;
            line-height: 140%;
          }
        }
      }

      .modules .module:not(.show) {
        height: auto;
        max-height: 68px;
        overflow: hidden;
      }
    }

    .limited-offer-holder {
      padding-top: 60px;
      padding-bottom: 100px;

      .limited-offer {
        .container {
          h2 {
            margin: 0 auto var(--spacing-40);
          }
        }

        .plan-features {
          text-align: left;
        }

        .price {
          align-items: flex-start;
        }

        .subtitle {
          font-size: 21px;
          line-height: 110%;
          display: block;
          text-align: center;

          .title-inline {
            display: block;
            width: 258px;
            margin: 10px 0;
          }
        }

        .heading {
          font-size: 32px;

          .text-2 {
            font-size: 32px;
            margin: 12px 0;
          }

          .text-3 {
            font-size: 32px;
          }
        }
      }

      .limited-offer-background {
        top: 0;
        bottom: 0;
        width: 100%;
        object-fit: cover;
        object-position: top;
        height: 100%;
      }
    }

    &.fa {
      .limited-offer-holder .limited-offer .heading {
        img.desktop-only {
          display: block !important;
        }

        .fa-block {
          font-weight: 700;
        }
      }
    }

    @media screen and (max-width: 920px) {
      .program-stats {
        .program-cards .container {
          .heading {
            margin-bottom: var(--spacing-36);

            .h2 {
              font-size: 32px;
              margin-bottom: var(--spacing-16);
            }
          }

          .modules .col {
            padding: 0 15px;

            .module {
              margin-top: 0;
              margin-bottom: 10px;

              &:last-of-type {
                margin-bottom: 0;
              }
            }
          }
        }
      }
    }
  }
}

@include bp($bp-phone) {
  .subtitle,
  .body-1,
  .body-2 {
    font-size: 21px;
  }

  .container.mobile-reset {
    padding-left: 0;
    padding-right: 0;

    .row.mobile-reset-row {
      margin-left: 0;
      margin-right: 0;
    }

    .col.mobile-reset-col {
      padding-left: 0;
      padding-right: 0;
    }
  }

  article.transform-your-future-2024 {
    .section-subtitle {
      font-size: 18px;
      line-height: 1.4;
    }

    section:not(.projects) .infinite-carousel .carousel .card {
      width: 100%;

      &:not(.course-card) {
        .image-wrapper {
          width: 100%;
        }

        .card-title {
          font-size: 24px;
        }

        .card-desc {
          font-size: 16px;
          line-height: 150%;
        }
      }
    }

    .program-stats {
      .program-cards .container {
        .modules .module.open {
          max-height: 1330px;
        }
      }

      .btn-primary {
        width: calc(100% - 48px);
        margin-top: var(--spacing-80);
      }
    }

    .long-reviews-holder {
      .long-reviews .container {
        .reviews-trustpilot {
          .reviews-heading {
            margin-bottom: var(--spacing-40);

            .title-block {
              width: 100%;
              max-width: 340px;
            }
          }

          .reviews-body {
            .reviews-body-holder {
              > div {
                padding: 0 var(--spacing-12);
              }

              .card-trustpilot-review {
                .text {
                  line-height: 140%;
                }
              }
            }
          }
        }
      }
    }

    .limited-offer-holder {
      .limited-offer {
        h2 {
          font-size: 32px;
          max-width: 100%;
          margin-bottom: var(--spacing-44);

          .fucsia {
            font-weight: 700;
          }
        }

        .switch-holder {
          margin-bottom: var(--spacing-14);

          span {
            font-size: 14px;
          }
        }

        .price {
          margin-top: 0;
          padding-bottom: 0;
          margin-bottom: var(--spacing-22);

          .regular-price {
            font-weight: 500;
            font-size: 22px;
            margin-top: 0;
          }

          .discounted-price {
            margin-bottom: 0;
            line-height: 100%;
            font-size: 52px;

            .promo-price {
              font-weight: 800;
              font-size: 52px;
            }

            .body-1 {
              position: relative;
              font-weight: 400;
              font-size: 18px;
            }
          }

          @media screen and (max-width: 390px) {
            .regular-price {
              font-size: 6vw;
            }

            .discounted-price {
              font-size: 13vw;
              white-space: nowrap;

              .promo-price {
                font-size: 13vw;
              }

              .body-1 {
                font-size: 5vw;
              }
            }
          }
        }

        .plan-features {
          display: block;
          width: 100%;
          margin-bottom: var(--spacing-44);

          .feature {
            margin-bottom: var(--spacing-14);

            &:last-of-type {
              margin-bottom: 0;
            }
          }
        }

        .subscribe-monthly,
        .subscribe-annual {
          width: 100%;
          max-width: 350px;
        }

        .vat-note {
          font-weight: 500;
        }
      }
    }
  }
}
</style>
